import React from 'react';
import { Pressable } from 'react-native';
import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { buttonShadow, green, sand, white } from '@/shared/styles/colors';
import * as Clipboard from 'expo-clipboard';
import useStore from '@/stores/useStore';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import SentryService from '@/services/sentry/Sentry.service';

interface ShareProfileUrlProps {
  shareProfileUrl: string;
}

const ShareProfileUrl: React.FC<ShareProfileUrlProps> = ({
  shareProfileUrl,
}) => {
  const isDesktop = useIsDesktop();
  const setSnackbarState = useStore((state) => state.setSnackbarState);

  const handleCopyPress = async () => {
    try {
      await Clipboard.setStringAsync(shareProfileUrl);
      setSnackbarState({
        open: true,
        message: 'Profile URL copied successfully!',
        severity: 'success',
      });
    } catch (error) {
      SentryService.captureError('Failed to copy URL to clipboard', error);
      setSnackbarState({
        open: true,
        message: 'Failed to copy URL to clipboard',
        severity: 'error',
      });
    }
  };

  return (
    <Container isDesktop={isDesktop}>
      <UrlText>Share profile url</UrlText>
      <CopyButton onPress={handleCopyPress}>
        <CopyButtonText>COPY</CopyButtonText>
      </CopyButton>
    </Container>
  );
};

export default ShareProfileUrl;

const Container = styled.View<{ isDesktop: boolean }>(({ isDesktop }) => ({
  width: isDesktop ? 390 : '100%',
  height: 48,
  backgroundColor: sand,
  borderRadius: 35,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: 27,
  paddingRight: 8,
}));

const UrlText = styled(BodyText)({
  fontSize: 14,
  fontWeight: 'bold',
  color: green,
  letterSpacing: -0.14,
});

const CopyButton = styled(Pressable)({
  width: 71,
  height: 32,
  backgroundColor: green,
  borderRadius: 78,
  justifyContent: 'center',
  alignItems: 'center',
  shadowColor: buttonShadow,
  shadowOffset: {
    width: 0,
    height: 1.86,
  },
  shadowRadius: 5.13,
  shadowOpacity: 0.18,
});

const CopyButtonText = styled(BodyText)({
  fontFamily: 'Lora',
  fontSize: 12,
  fontWeight: 'bold',
  color: white,
  letterSpacing: 0.241,
});
